<div class="">
    <div
        class="row no-gutters mb-3"
    >
        <div
            class="col d-flex justify-content-center lato blue"
            style="font-size: 1.5rem"
        >
            Thank you
        </div>
    </div>
    <div class="row no-gutters">
        <div
            class="lato"
            style="font-size: 0.875rem"
        >
            Your purchase is confirmed! Please look for an email with a copy of your receipt.
            <br />
            <br />
            Your INVOICE NUMBER is:
            <br />
            <span
                class="lato bold marine"
                style="font-size: 1.125rem"
            >{{ completedOrderId }}</span>
        </div>
    </div>

    <div
        class="action-container"
        style="margin-top: 2.125rem;"
    >
        <button
            class="btn btn-outline-danger btn-block"
            (click)="navigateToLandingPage()"
        >Return Home</button>
    </div>


</div>
